export default function Warranty() {
  return (
    <section id="warranty" className="py-0">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="bg-[#2E5C8A] text-white p-12 md:p-16 flex items-center justify-center">
          <div className="max-w-lg">
            <p className="text-4xl md:text-5xl font-serif leading-tight mb-8">
              <span className="text-6xl">"</span>6-Month Installation Warranty Backed by Technical Excellence
            </p>
            <div className="space-y-4 mb-8">
              <div className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-2xl text-[#FF6B35] flex-shrink-0"></i>
                <p className="text-white/90">Comprehensive coverage on all installation workmanship</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-2xl text-[#FF6B35] flex-shrink-0"></i>
                <p className="text-white/90">Professional inspection and rapid response service</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-2xl text-[#FF6B35] flex-shrink-0"></i>
                <p className="text-white/90">Protection against installation defects and material issues</p>
              </div>
            </div>
            <a href="#contact" className="inline-block px-8 py-3 border-2 border-white text-white font-semibold rounded-full hover:bg-white hover:text-[#2E5C8A] transition-all whitespace-nowrap cursor-pointer">
              View Full Terms
            </a>
          </div>
        </div>

        <div className="bg-orange-50 text-gray-800 p-12 md:p-16 flex items-center justify-center">
          <div className="max-w-lg">
            <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35] rounded-full mb-6">
              <i className="ri-file-list-3-line text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-gray-800 mb-6">Warranty Guidelines</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <div className="flex items-start space-x-3">
                <i className="ri-arrow-right-s-line text-xl text-[#FF6B35] flex-shrink-0 mt-1"></i>
                <p><strong>Inspection Required:</strong> All warranty claims must be verified by our technical staff to confirm coverage eligibility</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-arrow-right-s-line text-xl text-[#FF6B35] flex-shrink-0 mt-1"></i>
                <p><strong>Coverage Period:</strong> 6 months from final walkthrough signature and project acceptance</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-arrow-right-s-line text-xl text-[#FF6B35] flex-shrink-0 mt-1"></i>
                <p><strong>Exclusions:</strong> Warranty does not cover scratches, breakage, or damage from external impact, misuse, or improper maintenance</p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-arrow-right-s-line text-xl text-[#FF6B35] flex-shrink-0 mt-1"></i>
                <p><strong>Subfloor Conditions:</strong> Hidden moisture or structural issues discovered during installation will be addressed as additional work</p>
              </div>
            </div>
            <a href="#contact" className="inline-flex items-center text-[#2E5C8A] font-semibold mt-6 hover:text-[#2E5C8A]/80 transition-colors cursor-pointer">
              Download Complete T&C <i className="ri-download-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
